import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';

const ContactUs = () => {
  const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null;

  const [data, setData] = useState({
    name: "",
    email: "",
    mobile: "",
    remark: "",
    user_id: userData?.user_id,
    user_name: userData?.full_name,
  });

  const url = process.env.REACT_APP_API_URL;
  const [message, setMessage] = useState("");
  const [classname, setClassname] = useState([]);
  const [load, setLoad] = useState(false);
  const maxChars = 500;

  const handleMessageChange = (e) => {
    if (e.target.value.length <= maxChars) {
      setMessage(e.target.value);
    }
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(true);
    try {
      const response = await fetch(`${url}/leads`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...data,
          remark: message,
          property_id: process.env.REACT_APP_PERFUME_ID,
        }),
      });

      if (response.ok) {
        toast.success('Thank you for contacting!');
        setData({
          name: "",
          email: "",
          mobile: "",
          remark: "",
          user_id: userData?.user_id,
          user_name: userData?.full_name,
        });
        setMessage("");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoad(false);
    }
  };

  const fetchCenter = async () => {
    try {
      const response = await fetch(`https://100billionoms.top/classlevel/admin1997`);
      const res = await response.json();
      setClassname(res);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCenter();
  }, []);

  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} theme="colored" />
      <section className="contact-contact-us">
        <div className="contact-contact-header">
          <h2>Get In Touch</h2>
        </div>
        <div className="contact-contact-content">
          <div className="contact-contact-form">
            {/* <h3>Send us a Message</h3> */}
            <form onSubmit={handleSubmit}>
              <div className="contact-form-group">
                <label><i className="fa-solid fa-user"></i> Name</label>
                <input type="text" name='name' value={data.name} onChange={handleChange} placeholder="Enter your name" required />
              </div>
              <div className="contact-form-group">
                <label><i className="fa-solid fa-envelope"></i> Email</label>
                <input type="email" name='email' value={data.email} onChange={handleChange} placeholder="Enter your email" required />
              </div>
              <div className="contact-form-group">
                <label><i className="fa-solid fa-phone"></i> Phone</label>
                <input type="tel" name='mobile' value={data.mobile} onChange={handleChange} placeholder="Enter your phone number" required />
              </div>
              <div className="contact-form-group">
                <label><i className="fa-solid fa-message"></i> Message</label>
                <textarea
                  rows="4"
                  placeholder="Your message"
                  value={message}
                  onChange={handleMessageChange}
                ></textarea>
                <p style={{ color: message.length === maxChars ? "red" : "black", textAlign: "right" }}>
                  {message.length}/{maxChars} characters
                </p>
              </div>
              <button type="submit" className="contact-submit-btn" disabled={load}>
                <i className="fa-solid fa-paper-plane"></i> {load ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>

          <div className="contact-contact-info">
            <h3>Contact Information</h3>
            <p><i className="fa-solid fa-building"></i> Mumbai, MH - 400101, India</p>
            <p><i className="fa-solid fa-phone"></i> 8082080816</p>
            <p><i className="fa-solid fa-envelope"></i> cyclerental@gmail.com</p>

            {/* <div className="contact-social-icons">
              <a href="https://www.instagram.com/radicalskatingacademy/" target="_blank" rel="noreferrer">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a href="https://www.facebook.com/RadicalSkatingAcademy" target="_blank" rel="noreferrer">
                <i className="fa-brands fa-facebook"></i>
              </a>
              <a href="https://www.youtube.com/@radicalsportsacademy5024" target="_blank" rel="noreferrer">
                <i className="fa-brands fa-youtube"></i>
              </a>
            </div> */}
          </div>
        </div>

        {/* <div className="contact-map-container">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps?q=Airoli+Sector+8A,+Near+Dmart&output=embed"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div> */}
      </section>
    </>
  );
};

export default ContactUs;
